import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[datasource-directive]'
})
export class DatasourceDirective {

  constructor(public viewContainerRef: ViewContainerRef) { }

}
